module.exports = __webpack_public_path__ + "static/1-d8e80ec533bf83cb01d6161f2e9df3fa.jpg";